import React from "react";
import { noop } from "@common/helpers/function";
import { RuleSourceFilter as RuleSourceFilterValue } from "@common/types/transactionRule";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import {
    BaseFilterProps,
    defaultRuleSources,
    ruleSourceDisplayLabels,
} from "../../lib";

const isRuleSourceFilterValue = (
    value: FilterMultiselectValue,
): value is RuleSourceFilterValue =>
    Object.values(RuleSourceFilterValue).some((source) => source === value);

// Unmatched Kick rules are hidden unconditionally on the Rules page, so the
// option would be a no-op toggle.
const options: FilterMultiselectOption[] = Object.values(RuleSourceFilterValue)
    .filter((source) => source !== RuleSourceFilterValue.UNMATCHED_KICK)
    .map((source) => ({
        value: source,
        label: ruleSourceDisplayLabels[source],
        searchableLabel: ruleSourceDisplayLabels[source],
    }));

export const RuleSourceFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const sources =
        filters.ruleSources && filters.ruleSources.length > 0
            ? filters.ruleSources
            : defaultRuleSources;

    return (
        <FilterMultiselect
            inDropdown={false}
            searchable={false}
            options={options}
            value={sources}
            onChange={(val) => {
                onChange({
                    ruleSources: val.filter(isRuleSourceFilterValue),
                });
            }}
            name="ruleSources"
            onBlur={noop}
        />
    );
};
